<template>
  <nav id="aid-nav">
    <div class="inline-nav" v-if="false">
      <img class="logo" src="@/assets/senkoo.png" @click="$router.push({name:'home'})" />
      <div class="app-name">店长下单系统</div>
    </div>
    <img class="logo" src="@/assets/logo.png" style="width:84px;height:40px;" />
    <div class="inline-nav">
      <div class="logo-box">
        <a href="https://im.senkoo.cn" target="_blank" class="inline-nav">
          <a-icon type="customer-service" class="icon" />
          <span class="sk-link">{{$t('nav.onlineService')}}</span>
        </a>
      </div>
      <div class="logo-box">
        <a href="tel:+86400-052-1616" class="inline-nav">
          <a-icon type="customer-service" class="icon" />
          <span class="sk-link">{{$t('nav.telService')}}: +86-400-052-1616</span>
        </a>
      </div>
      <div class="logo-box desc">
        <img
          v-if="false"
          class="user"
          src="@/assets/user.jpg"
          style="width:24px;height:24px;"
          @click="toLogout"
        />
        <span
          class="icon noimg1"
          v-if="false"
        >{{user.role == 8 ? user.login_name : (user.name||'').slice(-2)}}</span>
        {{user.name}}
        <span>-CN{{user.role == 8 ? user.login_name : (user.name||'').slice(-2)}}</span>
      </div>
      <div @click="toLogout" class="logo-box inline-nav">
        <a-icon type="logout" class="icon logout" />
        <span class="sk-link">{{$t('nav.logout')}}</span>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      levelList: null
    };
  },
  computed: {
    ...mapGetters(["sideOpen", "user"]),
    isActive() {}
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    ...mapActions(["setSideOpen"]),
    toLogout() {
      this.$confirm({
        content: `${this.user.name}, ${this.$t("msg.confirmLogout")}`,
        onOk: () => {
          this.$store.dispatch("logout").then(() => {
            this.$router.push({ name: "login" });
          });
        }
      });
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return (
        name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase()
      );
    },
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        item => item.meta && item.meta.title
      );
      const first = matched[0];

      if (!this.isDashboard(first)) {
        matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      }

      this.levelList = matched.filter(
        item => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route;
      return params;
      // var toPath = pathToRegexp.compile(path);
      // return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    }
  }
};
</script>
<style scoped>
#aid-nav {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 48px;
  background: #fff;
}

.logo {
  /* width: 120px; */
  height: 16px;
  margin-right: 16px;
}
.app-name {
  padding: 0 16px;
  color: hsla(0, 0%, 0%, 0.85);
  position: relative;
}
.app-name::before {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  width: 1px;
  height: 16px;
  content: "";
  border-left: 1px solid hsla(0, 0%, 85%, 1);
}
.inline-nav {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.icon {
  font-size: 18px;
  margin-right: 6px;
  color: #000;
}
.user {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
}
.noimg1 {
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
  font-size: 14px;
  background: #f0f0f0;
  border: 1px dashed #fff;
}
.noimg {
  margin-left: 8px;
  line-height: 32px;
  cursor: pointer;
}
.logo-box {
  margin-left: 30px;
  display: inline-block;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: hsla(209, 100%, 55%, 1);
}
.desc {
  color: #333;
  cursor: text;
}
.logout {
  margin-right: 8px;
}
</style>